import React from "react";
import ContentVoiceOptions from './contentvoiceoptions';
import ContentAudioSample from "./contentaudiosample";
import {IM_CODES} from "../../../constants/imcodes";

const DONT_HAVE_TEXT:string="The following items do not have audio";

interface PropsType{
	showVoice:boolean;
    txtsList:string[];
    audioChosen:number;
    selectAudio:(optionIndex: number) => void;
}

export default class ContentAudio extends React.Component<PropsType>{

	private haveAudioList:string[];

	constructor(props:PropsType){
		super(props);
		this.haveAudioList=Object.keys(IM_CODES);
	}

    render(){
		if(this.props.showVoice===false)return null;

		let dontHaveList=[];
        let haveList=[];
		for(let i=0;i<this.props.txtsList.length;i++){
			if(this.haveAudioList.indexOf(this.props.txtsList[i])===-1){
				dontHaveList.push(this.props.txtsList[i]);
			}else{
				haveList.push(this.props.txtsList[i]);
            }
		}

		let dontHaves=dontHaveList.map((item:string)=>{
			return <li key={item}>{item}</li>
		})

        let showDontHaveList=dontHaveList.length>0&&this.props.audioChosen!==0;
		return(
            <div>
                <hr />
                <h1>Audio</h1>
				<div className='teachers-contentset-audiocontainer'>
                <ContentVoiceOptions
                    audioChosen={this.props.audioChosen}
                    selectAudio={this.props.selectAudio}
                />
                <ContentAudioSample
                    txtsList={haveList}
                    audioChosen={this.props.audioChosen}
                />
				</div>
				{showDontHaveList&&<div>
					<p>{DONT_HAVE_TEXT}</p>
					<ul>
						{dontHaves}
					</ul>
					</div>}
			</div>
		)
	}
}